<!-- ── Reenviar Código de Verificación ───────────────────────────────────── -->
<div class="tw-min-h-screen tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-12">
  <div class="tw-w-full tw-max-w-md">

    <!-- Card -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-200 tw-shadow-sm tw-overflow-hidden">

      <!-- Header -->
      <div class="tw-p-8 tw-pb-6 tw-text-center" style="background:linear-gradient(160deg,#0f172a 0%,#1e3a5f 50%,#1d4ed8 100%);">
        <div class="tw-mx-auto tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-mb-5">
          <svg class="tw-w-7 tw-h-7 tw-text-blue-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/>
          </svg>
        </div>
        <h1 class="tw-text-2xl tw-font-extrabold tw-text-white tw-mb-2">Reenviar código</h1>
        <p class="tw-text-blue-200 tw-text-sm tw-leading-relaxed">Ingresa tu correo electrónico y te enviaremos un nuevo código de verificación.</p>
      </div>

      <!-- Form -->
      <div class="tw-p-8">
        <form [formGroup]="formVer" (ngSubmit)="enviarCorreo()">

          <!-- Email -->
          <div class="tw-mb-5">
            <label for="email" class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-2">Correo electrónico</label>
            <input id="email" type="email" formControlName="email"
                   placeholder="tu@correo.com"
                   class="tw-w-full tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-800 tw-outline-none tw-transition focus:tw-border-blue-400 focus:tw-ring-2 focus:tw-ring-blue-100"
                   autocomplete="email">
            <div class="tw-mt-2 tw-text-xs tw-text-red-500" *ngIf="formVer.controls.email.errors && envioCorreo">
              <span *ngIf="formVer.controls.email.errors.required">El correo es requerido.</span>
              <span *ngIf="formVer.controls.email.errors.pattern">El correo no es válido.</span>
            </div>
          </div>

          <!-- reCAPTCHA -->
          <div class="tw-mb-6">
            <div class="tw-flex tw-justify-center">
              <ngx-recaptcha2 formControlName="recaptcha"
                  (success)="handleSuccess($event)"
                  (reset)="handleReset()"
                  (expire)="handleExpire()"
                  (load)="handleLoad()"
                  [siteKey]="calveSitio"
                  [size]="'normal'"
                  [hl]="lang"></ngx-recaptcha2>
            </div>
          </div>

          <!-- Submit -->
          <button type="submit" [disabled]="submitReenvioCorreo"
                  class="tw-w-full tw-py-3 tw-px-6 tw-rounded-xl tw-font-semibold tw-text-sm tw-text-white tw-transition tw-border-0 tw-cursor-pointer"
                  style="background:linear-gradient(135deg,#1d4ed8,#2563eb);"
                  [style.opacity]="submitReenvioCorreo ? '0.5' : '1'"
                  [style.cursor]="submitReenvioCorreo ? 'not-allowed' : 'pointer'">
            Enviar correo
          </button>

          <!-- Success / Error messages -->
          <div class="tw-mt-5">
            <div *ngIf="envioCorreo && mensajeExito"
                 class="tw-p-3 tw-rounded-xl tw-bg-green-50 tw-border tw-border-green-200 tw-text-sm tw-text-green-700 tw-text-center">
              {{ mensajeExito }}
            </div>
            <div *ngIf="envioCorreo && mensajeError"
                 class="tw-p-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-text-center">
              {{ mensajeError }}
            </div>
            <div *ngIf="mensajeUsuarioNull"
                 class="tw-p-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-text-center">
              {{ mensajeUsuarioNull }}
            </div>
          </div>
        </form>

        <!-- Enlace para volver a verificación -->
        <div class="tw-mt-6 tw-text-center">
          <p class="tw-text-sm tw-text-slate-500">
            ¿Ya tienes tu código?
            <a routerLink="/verificar" class="tw-font-semibold tw-text-blue-600 hover:tw-text-blue-800 tw-transition tw-cursor-pointer" style="text-decoration:none;">
              Verificar cuenta
            </a>
          </p>
        </div>
      </div>

    </div>
  </div>
</div>
